import { generateBaseQueryKeysList } from '@/queries/utils';

export const OPOBFF_CONTACT_KEYS = {
  main: 'opobffContacts',
};

export const opobffContactQueryKeys = generateBaseQueryKeysList(OPOBFF_CONTACT_KEYS.main);
